import { render, staticRenderFns } from "./InlineSpinner.vue?vue&type=template&id=2dcd886e&"
import script from "./InlineSpinner.vue?vue&type=script&lang=ts&"
export * from "./InlineSpinner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports